module.exports = __webpack_public_path__ + "img/nav_3_employer_contributions.46343e63.svg";